import React from 'react';
import { Badge } from 'react-bootstrap';
import { documentBookingSummary } from '../../Utils/bookingContext';

/**
 * The "Order(s)" cell of a document row: which order(s) it bills, and a chevron
 * to open their full context inline.
 *
 * Shared by the invoices list and the final-Számla queue. Both need the same
 * affordance — the reference, a "+N more" badge when the document spans several
 * orders, and expansion — so it lives once here; the tables differ only in the
 * secondary line they pass as `subline`.
 */
function ExpandableBookingsCell({
  bookings = [],
  fallbackRefs = [],
  expanded = false,
  onToggle = null,
  subline = null,
}) {
  const summary = documentBookingSummary({ bookings, order_references: fallbackRefs });
  // Nothing to reveal without context (a pre-context API, or a document linked
  // to no order) — render the reference as plain text rather than a dead control.
  const canExpand = !!onToggle && bookings.length > 0;
  const detail = subline !== null ? subline : summary.detail;

  const title = (
    <>
      {canExpand && (
        <i className={`fa fa-chevron-${expanded ? 'down' : 'right'} me-2 small text-muted`} />
      )}
      <span className="fw-medium">{summary.title}</span>
      {summary.extra > 0 && (
        <Badge bg="primary" className="ms-2 fw-normal">
          {`+${summary.extra} more`}
        </Badge>
      )}
    </>
  );

  return (
    <>
      {canExpand ? (
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none text-start"
          aria-expanded={expanded}
          onClick={onToggle}
        >
          {title}
        </button>
      ) : (
        <div>{title}</div>
      )}
      {detail && (
        <div
          className={`small text-muted text-truncate${canExpand ? ' ps-3' : ''}`}
          title={detail}
        >
          {detail}
        </div>
      )}
    </>
  );
}

export default ExpandableBookingsCell;
